import React from "react";
import moment from "moment";
import Badge from "Utils/Badge/Badge";
import { estadoCierreMensual } from "../../../../../helpers/tiposCierreMensual";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
const eliminarIcon = require("assets/img/icons/borrar.png");

// Las dos mitades que puede llevar el período, en el orden en que se registran
const MITADES = [
    { campo: "cierre_materia_prima", nombre: "Materia prima" },
    { campo: "cierre_bodega_produccion", nombre: "Bodega de producción" },
];

const formatearFechaHora = (fecha) =>
    fecha ? moment(fecha).format("DD/MM/YYYY - HH:mm") : "";

// Qué documento congeló cada mitad: el de bodega nombra el cierre diario que
// alimenta el reporte y hasta cuándo corta ese cierre —no el corte mensual, que
// va en su propia columna—; el de materia prima, el inventario de almacenes del
// período. Mientras la mitad no se registra se explica qué falta
const describirDocumento = (cierre, periodo) => {
    if (!cierre) {
        return periodo.estado !== "CERRADO"
            ? "El inventario de almacenes del período sigue abierto"
            : "—";
    }

    if (cierre.numero_cierre_bodega) {
        return (
            "Cierre de bodega " +
            cierre.numero_cierre_bodega +
            ", con corte al " +
            moment(cierre.fecha_corte_cierre_bodega).format(
                "DD/MM/YYYY HH:mm",
            )
        );
    }

    if (!cierre.fecha_cierre_periodo) {
        return "Inventario de almacenes del período";
    }

    return (
        "Inventario de almacenes cerrado el " +
        moment(cierre.fecha_cierre_periodo).format("DD/MM/YYYY")
    );
};

// Desglose que se abre debajo del período: una fila por mitad, con el documento
// que congeló y quién la registró. La anulación vive aquí porque es de la mitad
// y no del período, y cada tipo lleva su propia cadena: solo la última de la suya
// se puede anular
export const DetalleCierresPeriodo = ({ periodo, onAnular }) => {
    return (
        <table className="cierres-mensuales__detalle-table">
            <thead>
                <tr>
                    <th>Cierre</th>
                    <th>Estado</th>
                    <th style={{ minWidth: "210px" }}>Documento del reporte</th>
                    <th>Fecha de registro</th>
                    <th>Responsable</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                {MITADES.map((mitad) => {
                    const cierre = periodo[mitad.campo];

                    // cada tipo lleva su propia cadena y solo el último de la
                    // suya se puede anular. Va en null y no en false para que la
                    // celda caiga en el fallback cuando no hay nada que hacer
                    const anulable = cierre && cierre.es_ultimo ? cierre : null;

                    return (
                        <tr key={mitad.campo}>
                            <td className="text-center text-nowrap">
                                {mitad.nombre}
                            </td>
                            <td className="text-center text-nowrap">
                                <Badge {...estadoCierreMensual(cierre)} />
                            </td>
                            <td className="text-center">
                                {describirDocumento(cierre, periodo)}
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={
                                        cierre &&
                                        formatearFechaHora(
                                            cierre.fecha_creacion,
                                        )
                                    }
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={cierre && cierre.usuario_nombre}
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                <div className="table-actions">
                                    <NullableValue value={anulable}>
                                        <img
                                            src={eliminarIcon}
                                            alt="Anular"
                                            className="action_img"
                                            title="Anular este cierre"
                                            onClick={() => onAnular(anulable)}
                                        />
                                    </NullableValue>
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
